const BackgroundTreeMutations = {
  storeBackgroundTree(state, backgroundTree) {
    state.backgroundTree = backgroundTree
  },
  addBackgroundTreeItem(state, backgroundTreeItemData) {
    state.backgroundTree.add(backgroundTreeItemData)
  },
}
export default BackgroundTreeMutations
